import "./loader.scss";

export default function Loader({ text = "Loading...", size = "medium" }) {
  return (
    <div className={`loader ${size}`}>
      <span className="loader-spinner" aria-hidden="true"></span>
      <div>{text}</div>
    </div>
  );
}
